module.exports = __webpack_public_path__ + "7fd00830358b54370da773622c13e89e.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/tres caracoles.png
// module id = 628
// module chunks = 0